import { Audio, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import PatternDisplay from "../items/PatternDisplay";
import SnowLayer from "../items/SnowLayer";
import { centerSprite, enableUserClick } from "../phaserHelpers";
import SoundAssetKeys from "../SoundAssetKeys";
import GameplayScene from "./GameplayScene";

export default class ResultsScene extends Phaser.Scene
{
    static get KEY() { return 'ResultsScene'; }

    create()
    {
        this.landSound = SoundAssetKeys._land2;
        this.balls = [];

        const ss = gameData.ss;
        this.bg = this.add.sprite(0,0, ss, "Background").setOrigin(0);

        this.snowGroup = this.add.container();
        this.backSnow = new SnowLayer(this, 0, 0, this.atlasId);
        this.snowGroup.add(this.backSnow);
        this.children.moveAbove(this.snowGroup, this.bg)
        this.backSnow.startFill();

        this.scoreBg = this.add.sprite(148,142, ss, "Score_Bg").setOrigin(0);
        centerSprite(this.scoreBg);

        this.txtScore = this.add.bitmapText(-111, -111, 'darkblueFont', '558844', 48);
        centerSprite(this.txtScore);

        this.btnRestart = this.add.sprite(620,142,ss,"BUTTON_Restart");
        centerSprite(this.btnRestart);
        enableUserClick(this.btnRestart, this.clickRestart, this);

        this.tree = this.add.sprite(this.scale.width/2,0,ss, "Tree").setOrigin(.5, 0);

        this.tree.y = this.scale.height;

        this.snowBank = this.add.sprite(0,0,ss, "FrontSnowbank").setOrigin(0);
        this.snowBank.y = this.scale.height-this.snowBank.height;

        let tween = Tweens.addTween(this.tree, 900, {y:this.scale.height-this.tree.height}, Phaser.Math.Easing.Quadratic.In,()=>this.bringOrnaments());

        this.txtScore.text = gameData.score;

        tween = Tweens.addTween(this.scoreBg, 800, {y: {start:-this.scoreBg.height, to: this.scoreBg.y}, delay: 800, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out, ()=>{
            this.txtScore.x = this.scoreBg.x;
            this.txtScore.y = this.scoreBg.y+this.scoreBg.height*0.3;
        });

        tween = Tweens.addTween(this.btnRestart, 800, {y:{start: -this.scoreBg.height, to: this.scoreBg.y}, delay: 800, easeParams:[1, 0.3]}, Phaser.Math.Easing.Elastic.Out);
        this.makeOrnaments();
    }

    makeOrnaments() {
        const maxTileId = gameData.tileLevel;
        const userMade = gameData.totalMade;
        this.balls = [];
        let rows = 5;
        let rowCount = 1;
        let x = 0;
        let y = 0;
        let centerX = this.scale.width/2;
        let startY = 230;
        let colHeight = 140;
        let xoffset = 148/2;
        let padding = 6;
        for (let i=0;i<rows;i++)
        {
            for (let j=0;j<rowCount;j++)
            {
                if (this.balls.length < userMade) {
                    x = centerX - (rowCount-1)*xoffset/2 + xoffset*j-148/4 + (padding*(j+1))-rowCount/2*padding;
                    y = startY + (colHeight*i);
                    const item = new PatternDisplay(this, this.game, 0, 0, gameData.ss, 22);//this.add.sprite(x,y,BOP.ss,"OrnamentSelector");
                    this.add.existing(item);
                    item.destX = x;
                    item.destY = y;
                    item.colNum = j;
                    // item.pivot.x = 0.5;
                    // item.pivot.y = 0.5;
                    item.visible = false;
                    const pattern = [[Phaser.Math.RND.integerInRange(1,maxTileId),Phaser.Math.RND.integerInRange(1,maxTileId)],[Phaser.Math.RND.integerInRange(1,maxTileId),Phaser.Math.RND.integerInRange(1,maxTileId)]];
                    item.setPattern(pattern);
                    this.balls.push(item);
                    item.bg.indexId = this.balls.length-1;
                    enableUserClick(item.bg, ()=>this.clickBall(item.bg));
                }
            }
            rowCount++;
        }
    }

    bringOrnaments() {
        const len = this.balls.length;
        let d = 0;
        Audio.playOneShot(this.landSound, this);
        for (let i=0;i<len;i++)
        {
            this.balls[i].scaleX = 0.5;
            this.balls[i].scaleY = 0.5;
            this.balls[i].x = this.balls[i].destX;
            this.balls[i].y = -140;
            const tween = Tweens.addTween(this.balls[i], 800, {y:this.balls[i].destY , delay: d}, Phaser.Math.Easing.Quadratic.Out);

            tween.on('update',()=>this.balls[i].updateMaskPos());

            tween.on('complete',()=>this.balls[i].updateMaskPos());

            this.balls[i].updateMaskPos();
            this.balls[i].visible = true;
            d += Phaser.Math.RND.integerInRange(220,540);
        }
    };

    clickBall(sprite, pointer) {
        Audio.playOneShot(SoundAssetKeys._click_Copy, this)
        const maxTileId = gameData.tileLevel;
        const pattern = [[Phaser.Math.RND.integerInRange(1,maxTileId),Phaser.Math.RND.integerInRange(1,maxTileId)],[Phaser.Math.RND.integerInRange(1,maxTileId),Phaser.Math.RND.integerInRange(1,maxTileId)]];
        this.balls[sprite.indexId].setPattern(pattern);
    };

    clickRestart() {
        Audio.playOneShot(SoundAssetKeys._click_Copy, this);
        this.scene.start(GameplayScene.KEY)
    };

}